import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SeatTradeTradesOverview from '../../containers/SeatTrade/SeatTradeTradesOverview'
import Modal from '../Modal'

class SeatTradeModal extends Component {
  handleClose = () => {
    const { isLoading, setContextMenu } = this.props
    if (!isLoading) {
      setContextMenu('')
    }
  }

  render() {
    const { classes, isOpen } = this.props

    return (
      <Modal
        className={classes.resize}
        isOpen={isOpen}
        onClose={this.handleClose}
      >
        <SeatTradeTradesOverview />
      </Modal>
    )
  }
}

SeatTradeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setContextMenu: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    resize: PropTypes.string.isRequired,
  }).isRequired,
}

export default SeatTradeModal
